import ConditionCreateVoiceImg from '@src/assets/images/vc-condition-create-voice.png';
import QuietFaceImg from '@src/assets/images/vc-quiet-face.png';
import SpeakNaturalImg from '@src/assets/images/vc-speak-natural.png';
import MicrophoneImg from '@src/assets/images/vc-microphone.png';
import FlagVNImg from '@src/assets/images/vc-flag-vn.png';

export const notes = [
  {
    id: 'conditionCreateVoice',
    icon: ConditionCreateVoiceImg,
    title: 'conditionCreateVoice',
    text: 'noteConditionCreateVoice',
  },
  {
    id: 'findQuietPlace',
    icon: QuietFaceImg,
    title: 'findQuietPlace',
    text: 'noteFindQuietPlace',
  },
  {
    id: 'speakNatural',
    icon: SpeakNaturalImg,
    title: 'speakNatural',
    text: 'noteSpeakNatural',
  },
  {
    id: 'microphoneAuthorized',
    icon: MicrophoneImg,
    title: 'microphoneAuthorized',
    text: 'noteMicrophoneAuthorized',
  },
  {
    id: 'supportLanguageVN',
    icon: FlagVNImg,
    title: 'supportLanguageVN',
    text: 'noteSupportLanguageVN',
  },
];
